"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author VRu
 */


var ReceiptLineConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReceiptLineConverter, _DataObjectConverter_);

  function ReceiptLineConverter() {
    _classCallCheck(this, ReceiptLineConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReceiptLineConverter).apply(this, arguments));
  }

  return ReceiptLineConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReceiptLineConverter = ReceiptLineConverter;